var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification",on:{"click":_vm.close}},[_c('div',{staticClass:"notification-box thinly-shadowed"},[_c('h1',{class:_vm.context == null ? '' : _vm.context},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('h2',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }